import { FormattedMessage } from 'react-intl'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {ServicesListFilter} from './ServicesListFilter'

const ServicesListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddServiceModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-service-table-toolbar='base'>
      <ServicesListFilter />

      {/* begin::Export */}
      <button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        <FormattedMessage id='TABLE.GENERAL.EXPORT' />      </button>
      {/* end::Export */}

      {/* begin::Add service */}
      <button type='button' className='btn btn-primary' onClick={openAddServiceModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        <FormattedMessage id='SERVICE.TABLE.CREATESERVICE' />
      </button>
      {/* end::Add service */}
    </div>
  )
}

export {ServicesListToolbar}
